import { put } from "redux-saga/effects";

import { ApiCaller, Utils } from "../../config";
import { UserAction } from "../actions";

export default class UserMiddleware {
  static *GetUserListing({ payload, cb }) {
    try {
      const {
        limit = 10,
        offset = 0,
        keyword = "",
        status = "",
        location_Id = "",
        location_type = "",
        is_admin_assign = null,
      } = payload;

      // Build query string conditionally
      let queryParams = `offset=${offset}&keyword=${keyword}&limit=${limit}&status=${status}&location_Id=${location_Id}&location_type=${location_type}`;

      // Only add is_admin_assign if it's not null
      if (is_admin_assign !== null) {
        queryParams += `&is_admin_assign=${is_admin_assign}`;
      }

      let res = yield ApiCaller.Get(`/users?${queryParams}`);
      if (res.status == 200) {
        yield put(UserAction.getUserListingSuccess(res.data.data));
        if (cb) {
          cb();
        }
      } else {
        yield put(UserAction.getUserListingFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(UserAction.getUserListingFailure());
      //   Utils.showSnackBar({
      //     message: "Reset password failed",
      //     severity: "error",
      //   });
    }
  }

  static *ChangeUserStatus({ id, cb }) {
    try {
      let res = yield ApiCaller.Put(`/users/status/toggle?user_id=${id}`);
      if (res.status == 201) {
        yield put(UserAction.changeUserStatusSuccess(res.data.data));
        Utils.showSnackBar({
          message: res.data.message,
        });
        if (cb) {
          cb();
        }
      } else {
        yield put(UserAction.changeUserStatusFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(yield put(UserAction.changeUserStatusFailure()));
    }
  }

  static *GetUserLocations({ keyword, cb }) {
    try {
      let res = yield ApiCaller.Get(
        `/location/search?limit=30&offset=0&keyword=${keyword}`
      );
      if (res.status == 200) {
        yield put(UserAction.getUserLocationsSuccess(res.data.data));
        if (cb) {
          cb();
        }
      } else {
        yield put(UserAction.getUserLocationsFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(UserAction.getUserLocationsFailure());
    }
  }

  static *SendUserEmail({ payload, cb }) {
    console.log("send_user_email_action_called", payload);

    try {
      const formData = new FormData();
      formData.append("user_id", payload.user_id);
      formData.append("message", payload.message);

      if (payload.attachments && payload.attachments.length > 0) {
        payload.attachments.forEach((file) => {
          formData.append("attachments[]", file);
        });
      }

      let res = yield ApiCaller.Post("/user/email", formData);
      if (res.status === 200 || res.status === 201) {
        yield put(UserAction.sendUserEmailSuccess(res.data.data));
        Utils.showSnackBar({
          message: res.data.message || "Email sent successfully",
        });
        if (cb) {
          cb();
        }
      } else {
        yield put(UserAction.sendUserEmailFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(UserAction.sendUserEmailFailure());
      Utils.showSnackBar({
        message: "Failed to send email",
        severity: "error",
      });
    }
  }

  static *SendBulkEmail({ payload, cb }) {
    try {
      const formData = new FormData();
      formData.append("is_admin_assign", true);
      formData.append("message", payload.message);

      if (payload.attachments && payload.attachments.length > 0) {
        payload.attachments.forEach((file) => {
          formData.append("attachments", file);
        });
      }

      let res = yield ApiCaller.Post("/users/email", formData);
      if (res.status == 200 || res.status == 201) {
        yield put(UserAction.sendBulkEmailSuccess(res.data.data));
        Utils.showSnackBar({
          message: res.data.message || "Bulk email sent successfully",
        });
        if (cb) {
          cb();
        }
      } else {
        yield put(UserAction.sendBulkEmailFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(UserAction.sendBulkEmailFailure());
      Utils.showSnackBar({
        message: "Failed to send bulk email",
        severity: "error",
      });
    }
  }

  static *DeleteUser({ id, cb }) {
    console.log(id, "idddddddddddddddd");
    try {
      let res = yield ApiCaller.Delete("/user/delete", { user_id: id });
      if (res.status == 200 || res.status == 201) {
        yield put(UserAction.deleteUserSuccess(res.data.data));
        Utils.showSnackBar({
          message: res.data.message || "User deleted successfully",
        });
        if (cb) {
          cb();
        }
      } else {
        yield put(UserAction.deleteUserFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(UserAction.deleteUserFailure());
      Utils.showSnackBar({
        message: "Failed to delete user",
        severity: "error",
      });
    }
  }

  static *CreateUser({ payload, cb }) {
    try {
      let res = yield ApiCaller.Post("/user/create", payload);
      if (res.status == 200 || res.status == 201) {
        yield put(UserAction.createUserSuccess(res.data.data));
        Utils.showSnackBar({
          message: res.data.message || "User created successfully",
        });
        if (cb) {
          cb();
        }
      } else {
        yield put(UserAction.createUserFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(UserAction.createUserFailure());
      Utils.showSnackBar({
        message: "Failed to create user",
        severity: "error",
      });
    }
  }
}
